export default {
    "name": "VehicleBreakEvenReportData",
    "kind": "HoudiniQuery",
    "hash": "8c08df1d494caabe7f41d8556aaa1317c02bbae6587674ee4053f094ad797886",

    "raw": `query VehicleBreakEvenReportData($vehicleId: Int!) {
  vehicle(id: $vehicleId) {
    reportData {
      breakEven {
        date
        expensesCount
        expensesTotal
        expensesDescription
        salesCount
        salesTotal
        salesDescription
        costOfGoodsSoldTotal
      }
    }
    id
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "vehicle": {
                "type": "Vehicle",
                "keyRaw": "vehicle(id: $vehicleId)",
                "nullable": true,

                "selection": {
                    "fields": {
                        "reportData": {
                            "type": "VehicleReportData",
                            "keyRaw": "reportData",

                            "selection": {
                                "fields": {
                                    "breakEven": {
                                        "type": "VehicleBreakEvenReportData",
                                        "keyRaw": "breakEven",

                                        "selection": {
                                            "fields": {
                                                "date": {
                                                    "type": "Date",
                                                    "keyRaw": "date",
                                                    "visible": true
                                                },

                                                "expensesCount": {
                                                    "type": "Int",
                                                    "keyRaw": "expensesCount",
                                                    "visible": true
                                                },

                                                "expensesTotal": {
                                                    "type": "Decimal2",
                                                    "keyRaw": "expensesTotal",
                                                    "visible": true
                                                },

                                                "expensesDescription": {
                                                    "type": "String",
                                                    "keyRaw": "expensesDescription",
                                                    "visible": true
                                                },

                                                "salesCount": {
                                                    "type": "Int",
                                                    "keyRaw": "salesCount",
                                                    "visible": true
                                                },

                                                "salesTotal": {
                                                    "type": "Decimal2",
                                                    "keyRaw": "salesTotal",
                                                    "visible": true
                                                },

                                                "salesDescription": {
                                                    "type": "String",
                                                    "keyRaw": "salesDescription",
                                                    "visible": true
                                                },

                                                "costOfGoodsSoldTotal": {
                                                    "type": "Decimal2",
                                                    "keyRaw": "costOfGoodsSoldTotal",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "vehicleId": "Int"
        },

        "types": {},
        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=647d938d7ac8d42c473c73833b9c2a4d177a510e8f998d54c200bca3f6ab582a";